import Controller from "@ember/controller";

export default class GroupManageProfileController extends Controller {
  saving = null;
}
